// @ts-nocheck
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "./SelfLearningHierarchyTemplate";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../../../runtime/json/scalar";
import { WireType, } from "../../../../../../runtime/wire/index";
import { default as serialize, } from "../../../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        selfLearningHierarchyId: "0",
        template: undefined,
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.selfLearningHierarchyId !== undefined)
        result.selfLearningHierarchyId = tsValueToJsonValueFns.int64(value.selfLearningHierarchyId);
    if (value.template !== undefined)
        result.template = encodeJson_1(value.template);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.selfLearningHierarchyId !== undefined)
        result.selfLearningHierarchyId = jsonValueToTsValueFns.int64(value.selfLearningHierarchyId);
    if (value.template !== undefined)
        result.template = decodeJson_1(value.template);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.selfLearningHierarchyId !== undefined) {
        const tsValue = value.selfLearningHierarchyId;
        result.push([1, tsValueToWireValueFns.int64(tsValue)]);
    }
    if (value.template !== undefined) {
        const tsValue = value.template;
        result.push([2, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.selfLearningHierarchyId = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.template = value;
    }
    return result;
}
